import { render, staticRenderFns } from "./FlowPostToConversation.vue?vue&type=template&id=64eef6b7&scoped=true&"
import script from "./FlowPostToConversation.vue?vue&type=script&lang=js&"
export * from "./FlowPostToConversation.vue?vue&type=script&lang=js&"
import style0 from "./FlowPostToConversation.vue?vue&type=style&index=0&id=64eef6b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eef6b7",
  null
  
)

export default component.exports